/**
 * package: com.inq.flash.messagingframework
 * class: Message
 * root Object
 * @constructor
 */
com.inq.flash.messagingframework.Message = function() {
	this.data = {};
	this.data[com.inq.flash.client.data.MessageFields.KEY_VERSION] = "0.05";
	this.data[com.inq.flash.client.data.MessageFields.WINDOW_ID_PARAM] = com.inq.flash.client.control.FlashVars.getWindowId();
	this.initialDataIndex = 0;
};
$hxClasses['com.inq.flash.messagingframework.Message'] = com.inq.flash.messagingframework.Message;
/** @private @type {Array} */
com.inq.flash.messagingframework.Message.__name__ = ["com","inq","flash","messagingframework","Message"];


/**
 * toString
 *
 * $type TFun([],TInst(String,[]))
 * @public
 * @this com.inq.flash.messagingframework.Message
 * @return {string}
 */
com.inq.flash.messagingframework.Message.prototype.toString = function() {
	/** @type {string} */
	var dataString = "";
	/* 	var data_dictionary : Iterator<Dynamic> = untyped (__keys__(data)).iterator(); */
	/** @type {Array} */
	var keyz = com.inq.utils.Util.fields(this.data);
	var /** @type {number} */ _g1 = 0, /** @type {number} */ _g = keyz.length;
	while(_g1 < _g) {
		var /** @type {number} */ ix = _g1++;
		var /** @type {string} */ key = keyz[ix];
		if(key != "") {
			/** @type {string} */
			var item = "";
			try {
				/** @type {string} */
				var valu = this.data[key];
				if(valu != null) item = key + "=" + this.data[key] + "\n";
			} catch( e ) {
				if( js.Boot.__instanceof(e,Error) ) {
					haxe.Log.trace("bad key: " + key + " error: " + Std.string(e),{ fileName : "Message.js", lineNumber : 79, className : "com.inq.flash.messagingframework.Message", methodName : "toString"});
				} else throw(e);
			}
			dataString += item;
		}
	}
	dataString += "\n";
	return dataString;
};


/**
 * serializeToURL
 *
 * $type TFun([],TInst(String,[]))
 * @public
 * @this com.inq.flash.messagingframework.Message
 * @return {string}
 */
com.inq.flash.messagingframework.Message.prototype.serializeToURL = function() {
    var dataString = "";
    for(var key in this.data) {
        if(key) {
            var valu = this.data[key];
            if (valu != null && typeof valu != "function") {
                var item = "&" + key + "=" + encodeURIComponent(valu.toString());
                dataString += item;
            }
        }
    }
    return dataString;
};

/**
 * getMessageType
 *
 * $type TFun([],TInst(String,[]))
 * public function getMessageType():String
 * @public
 * @this com.inq.flash.messagingframework.Message
 * @return {string}
 */
com.inq.flash.messagingframework.Message.prototype.getMessageType = function() {
	return this.data[com.inq.flash.client.data.MessageFields.KEY_MESSAGE_TYPE];
};

/**
 * Compares given message type with message type of current message.
 *
 * @param {string} messageType - message type
 * @return {boolean} true if given messageType matches the message type.
 */
com.inq.flash.messagingframework.Message.prototype.isMessageType = function (messageType) {
	return messageType === this.getMessageType();
};

/**
 * Checks message type.
 *
 * @return {boolean} true if current message is chat.accepted
 */
com.inq.flash.messagingframework.Message.prototype.isChatAccepted = function () {
	return (this.isMessageType(com.inq.flash.client.data.MessageFields.TYPE_STATE_CHANGE)
			&& com.inq.flash.client.data.MessageFields.DATA_STATE_ASSIGNED
				=== this.getProperty(com.inq.flash.client.data.MessageFields.KEY_STATE))
		|| this.isMessageType(com.inq.flash.client.data.MessageFields.TYPE_CHAT_ACCEPTED);
};

/**
 * Checks message type.
 *
 * @return {boolean} true if current message is transfer response
 */
com.inq.flash.messagingframework.Message.prototype.isChatTransfer = function () {
	return (this.isMessageType(com.inq.flash.client.data.MessageFields.TYPE_STATE_CHANGE)
			&& com.inq.flash.client.data.MessageFields.DATA_STATE_TRANSFER
				=== this.getProperty(com.inq.flash.client.data.MessageFields.KEY_STATE))
		|| this.isMessageType(com.inq.flash.client.data.MessageFields.TYPE_CHAT_TRANSFER_RESPONSE);
};

/**
 * Checks message type.
 *
 * @return {boolean} true if current message is conference state
 */
com.inq.flash.messagingframework.Message.prototype.isChatConference = function () {
	return (this.isMessageType(com.inq.flash.client.data.MessageFields.TYPE_STATE_CHANGE)
			&& com.inq.flash.client.data.MessageFields.DATA_STATE_CONFERENCE
				=== this.getProperty(com.inq.flash.client.data.MessageFields.KEY_STATE))
		|| this.isMessageType(com.inq.flash.client.data.MessageFields.TYPE_OWNER_TRANSFER_RESPONSE);
};

/**
 * getProperty
 *
 * $type TFun([{ name => name, t => TInst(String,[]), opt => false }],TInst(String,[]))
 * public function getProperty(name:String):String
 * @public
 * @this com.inq.flash.messagingframework.Message
 * @param {string}  name 
 * @return {string}
 */
com.inq.flash.messagingframework.Message.prototype.getProperty = function(name) {
	return this.data[name];
};

/**
 * Returns the message property converted to Date.
 * @public
 * @this com.inq.flash.messagingframework.Message
 * @param {String} name - message property
 * @return {Date}
 */
com.inq.flash.messagingframework.Message.prototype.getPropertyAsDate = function(name) {
	/** @type {Number} */
	var timestamp = parseInt(this.getProperty(name));
	if (!isNaN(timestamp)) {
		return new Date(timestamp);
	} else {
		return null;
	}
};

/**
 * Function is used to get from this message boolean representation of property
 * which is associated with given name.
 *
 * @param {string} name - name of property
 * @returns {boolean} returns value of property converted to boolean
 */
com.inq.flash.messagingframework.Message.prototype.getPropertyAsBoolean = function (name) {
	/** @type {string} */
	var value = this.getProperty(name);

	if (value) {
		if (typeof value === "boolean") {
			return value;
		}

		return com.inq.flash.messagingframework.StringUtils.getBooleanValue(value);
	}

	return false;
};

/**
 * addProperty
 *
 * $type TFun([{ name => name, t => TInst(String,[]), opt => false },{ name => value, t => TInst(String,[]), opt => false }],TEnum(Void,[]))
 * public function addProperty(name:String, value:String):Void
 * @public
 * @this com.inq.flash.messagingframework.Message
 * @param {string}  name 
 * @param {string}  value 
 * @return {void}
 */
com.inq.flash.messagingframework.Message.prototype.addProperty = function(name,value) {
	this.data[name] = value;
};

/**
 * addPropertyIfNotNull
 *
 * @public
 * @this com.inq.flash.messagingframework.Message
 * @param {string}  name
 * @param {string}  value
 * @return {void}
 */
com.inq.flash.messagingframework.Message.prototype.addPropertyIfNotNull = function(name, value) {
	if (value != null) { // The undefined value is also can't pass this check
		this.data[name] = value;
	}
};


/**
 * nextInitialDataIndex
 *
 * $type TFun([],TInst(Int,[]))
 * public function nextInitialDataIndex():Int
 * @public
 * @this com.inq.flash.messagingframework.Message
 * @return {number}
 */
com.inq.flash.messagingframework.Message.prototype.nextInitialDataIndex = function() {
	return this.initialDataIndex++;
};


com.inq.flash.messagingframework.Message.prototype.setData = function(fields) {
    if (typeof fields == "object") {
        this.data = fields;
    } else if (typeof fields == "string") {
        var lines = fields.split("\n");
        for ( var i = 0; i < lines.length ; i++ ) {
            this.addProperty(lines[i].slice( 0, lines[i].indexOf("=") ), lines[i].slice( lines[i].indexOf("=") + 1 ));
        }
    }
};

/**
 * setMessageType
 *
 * $type TFun([{ name => messageType, t => TInst(String,[]), opt => false }],TEnum(Void,[]))
 * public function setMessageType(messageType: String):Void
 * @public
 * @this com.inq.flash.messagingframework.Message
 * @param {string}  messageType 
 * @return {void}
 */
com.inq.flash.messagingframework.Message.prototype.setMessageType = function(messageType) {
	this.data[com.inq.flash.client.data.MessageFields.KEY_MESSAGE_TYPE] = messageType;
};

/**
 * Set the property, if it exist and the value is not null
 * @param {string} name - name of property
 * @param {string} value - value
 */
com.inq.flash.messagingframework.Message.prototype.setPropertyIfNotNullIfExists = function (name, value) {
	if (this.getProperty(name)) {
		this.addPropertyIfNotNull(name, value);
	}
};


/**
 * Publish the method to use it in CIAPI
 * in accordance with the recommendations of the Google Closure compiler.
 * @public
 */
com.inq.flash.messagingframework.Message.prototype["getPropertyValue"] = com.inq.flash.messagingframework.Message.prototype.getProperty;

/**
 * Publish the method to use it in CIAPI
 * in accordance with the recommendations of the Google Closure compiler.
 * @public
 */
com.inq.flash.messagingframework.Message.prototype["getPropertyValueAsBoolean"] = com.inq.flash.messagingframework.Message.prototype.getPropertyAsBoolean;

/** @private @type {boolean} */
com.inq.flash.messagingframework.Message.prototype.postSend = null;
/** @private @type {com.inq.utils.Dictionary} */
com.inq.flash.messagingframework.Message.prototype.data = null;
/** @private @type {number} */
com.inq.flash.messagingframework.Message.prototype.initialDataIndex = null;
/** @type {com.inq.flash.messagingframework.Message} */
com.inq.flash.messagingframework.Message.prototype.__class__ = com.inq.flash.messagingframework.Message;
